<template>
	<div class="newRulesDetails editFroms">
		<div class="tableTitle">
			{{title}}
		</div>
		<el-table ref="multipleTable" class="qcTable distributionTable rightAngle" :data="list" max-height="300">
			<el-table-column prop="Type" label="类型">
				<template slot-scope="scope">
					<span v-show="scope.row.Type == 1">
                        影像
                    </span>
					<span v-show="scope.row.Type == 2">
                        报告
                    </span>
					<span v-show="scope.row.Type == 3">
                        病史
                    </span>
					<span v-show="scope.row.Type == 0">
                        全部
                    </span>
				</template>
			</el-table-column>
			<el-table-column prop="Description" label="细则"></el-table-column>
			<el-table-column prop="ModalityType" label="设备">
				<template slot-scope="scope">
					{{scope.row.ModalityType}}
				</template>
			</el-table-column>
			<el-table-column prop="Score" label="分值"></el-table-column>
			<el-table-column prop="Sort" label="排序(以数字从小到大进行排序)">
				<template slot-scope="scope" slot="header">
					<el-tooltip class="item" effect="dark" content="以数字从小到大进行排序" placement="bottom">
						<span>排序 <i class="el-icon-info" style="color: #248AFD;"></i></span>
					</el-tooltip>
				</template>
				<template slot-scope="scope">
					<el-input v-model.number="scope.row.Sort"></el-input>
				</template>
			</el-table-column>
			<template slot="empty">
		      	<div>
					<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
				</div>
				<div class="text">暂无数据</div>
		    </template>
		</el-table>

	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		props: {
			list: {},
			title: '',
		},
		computed: {
			...Vuex.mapState('managerPlan', [])
		},
		methods: {
			...Vuex.mapMutations('managerPlan', ['']),
			...Vuex.mapActions('managerPlan', ['']),
			handleSelectionChange(val) {
			}
		}

	}
</script>